// Burger.styled.js
import styled from 'styled-components'
export const StyledRightWrong = styled.div`
  margin: 0 1rem;
  path {
    opacity: 0;
    transition: opacity 0.3s ease-out;
  }
`
